/**
 * DrillableValue - Any value with provenance becomes a door to its evidence
 *
 * Wraps a displayed value (dollar amount, vendor name, count) so clicking it
 * opens the shared TransactionsDrilldownModal (via SankeyDrilldownAdapter)
 * filtered to the records behind that value — the same PO viewer used by
 * Sankey, Vendor Analysis, Tech Stack, and interactive diagrams.
 *
 * drill shape:
 * {
 *   nodeType: 'vendor_name' | 'supplier' | 'component' | 'category' | 'component_type',
 *   nodeValue: 'Check Point',          // required
 *   department: 'CDCR',                // optional context filter
 *   department_code: '5225',           // optional
 *   start_date: '2024-01-01',          // optional
 *   end_date: '2025-01-01',            // optional
 * }
 *
 * If drill is missing or incomplete, children render unchanged — safe to wrap
 * everything.
 */
import React, { useState, useCallback } from 'react';
import SankeyDrilldownAdapter from '../../../SankeyFlowChart/SankeyDrilldownAdapter';
import './DrillableValue.css';

export default function DrillableValue({ drill, children, title }) {
  const [open, setOpen] = useState(false);

  const handleClick = useCallback((e) => {
    e.stopPropagation();
    setOpen(true);
  }, []);

  if (!drill?.nodeType || !drill?.nodeValue) {
    return <>{children}</>;
  }

  return (
    <>
      <button
        type="button"
        className="cc-drillable"
        onClick={handleClick}
        title={title || `View transactions for ${drill.nodeValue}`}
      >
        {children}
      </button>
      {open && (
        <SankeyDrilldownAdapter
          node={{ nodeType: drill.nodeType, nodeValue: drill.nodeValue }}
          isOpen={open}
          onClose={() => setOpen(false)}
          department={drill.department || null}
          departmentCode={drill.department_code || null}
          startDate={drill.start_date || null}
          endDate={drill.end_date || null}
        />
      )}
    </>
  );
}
